<template>
    <div class="card">
        <div class="card-body">
            <b-row>
                <b-col cols="4">
                    <div style="text-align: center; padding-left: 5%; padding-right:5%;" class="height: 20rem;">
                        <div class="height: 2rem;">
                            <i style="font-size: 2rem; color: limegreen;" class="fas fa-user"></i>
                        </div>
                        <h4><strong>{{status.license_applications}}</strong> Applicants License Applications</h4>
                    </div>
                </b-col>

                <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                    <div class="height: 2rem;">
                        <i style="font-size: 2rem; color: dodgerblue;" class="far fa-bell"></i>
                    </div>
                    <h4><strong>{{status.applicant_responses}}</strong> Applicant Responses Received</h4>
                </b-col>


                <b-col cols="4" style="text-align: center; padding-left: 5%; padding-right: 5%;">
                    <div class="height: 2rem;">
                        <i style="font-size: 2rem; color: red;" class="far fa-question-circle"></i>
                    </div>
                    <h4><strong>{{status.queries}}</strong> Queries Awaiting Response</h4>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { ccbAdminState } from '@/state/helpers';
export default {
    data:() => ({
        status:{
            license_applications: 0,
            applicant_responses: 0,
            queries: 0,
        }
    }),
    watch:{
        clients(newValue){
            if(newValue != null){
                this.setStatusData();
            }
        }
    },
    computed:{
        ...ccbAdminState,
    },
    methods:{
        setStatusData(){
            this.status.license_applications = this.clients.length;

            let queries = 0;
            this.clients.forEach(element => {
                if(element.action_required){
                    queries++;
                }
            });
            this.status.queries = queries;

            //this.applicant_responses = 0;
        }
    },
    mounted(){
        if(this.clients != null){
            this.setStatusData();
        }
    },
}
</script>

<style>

</style>